// SEQ-180 legibility follow-up (15 September 2026): a legend label, in text
// colour rather than in its own series colour.
//
// WHY ITS OWN FILE. It returns JSX, so it cannot live beside the pure helpers
// in features/pnlAnalytics; and it is not a component, so it cannot live beside
// the components in PnlChartFrame.tsx without tripping
// react-refresh/only-export-components. Same reason pnlAnalyticsFormat.ts
// exists as its own module.
//
// WHAT IT FIXES. Recharts colours legend TEXT with the series colour unless
// told otherwise, which is how "Overtime % revenue" rendered at 2.15:1 and
// "Profit %" at 2.54:1, both at 12px, with nothing in the source to point at.
// Passing this as a legend's `formatter` is the supported way to style the
// label. The coloured swatch Recharts draws beside it is untouched: a swatch is
// a graphic, with a 3:1 bar to clear rather than a 4.5:1 one.
//
// Shared rather than written per chart, because the ABSENCE was the defect. A
// legend with no formatter is the failing case, and four of them shipped.
import "./PnlWidgetCharts.css";

export function pnlLegendLabel(value: string) {
  return <span className="pnl-legend-label">{value}</span>;
}
